import { messaging } from './firebase-config';
import { getToken, onMessage } from 'firebase/messaging';

export const requestPermissionAndGetToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log("Permission not granted");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: "BDBm2p_az6FswtkPDvtynAM5LNR-VmCLdCHqtaVcrGyvIB_nd4GUpQ1veHcW_1urbjSkb_Ae4D3dYNw8vQag2qU" // from Firebase Cloud Messaging settings
    });

    if (token) {
      //console.log("FCM Token:", token);
    } else {
      console.log("No registration token available");
    }

    return token;
  } catch (err) {
    console.error("An error occurred while retrieving token.", err);
    return null;
  }
};

export const listenForMessages = () => {
  onMessage(messaging, () => {
    //console.log("Foreground message received:", payload);
    // Show toast/notification in app
  });
};
